import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { Colors } from 'src/components/theme'
import { APP_PATHNAMES, APP_SECTIONS_ROUTES } from 'src/layout/utils/routing'
import { AlphamapLogoThrobber } from 'src/components/alphamap-logo/throbber'

type ContentLoaderProps = {
  active?: boolean
}

const Wrapper = styled.div<{ active: boolean }>`
  position: fixed;

  transition: all 0.2s ease-in-out;
  opacity: ${({ active }) => (active ? 1 : 0)};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  z-index: 99999;
  background-color: ${Colors.bgLight};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContentLoader = (props: ContentLoaderProps) => {
  const { active = true } = props
  const styles = {
    left: `80px`,
    top: 0,
    width: `calc(100vw - 80px)`,
    height: `100vh`,
  }

  return (
    <Wrapper style={styles} active={active}>
      <AlphamapLogoThrobber />
    </Wrapper>
  )
}

export const PathSwitchLoader = () => {
  const router = useRouter()
  const [active, setActive] = useState(false)

  const handleRouteChangeStart = (url: string) => {
    // Prevent loader from showing on map explorer
    if (
      router.pathname === APP_PATHNAMES.mapExplorer &&
      (APP_SECTIONS_ROUTES.mapExplorer.some((path) => url.includes(path)) || url === '/')
    ) {
      return
    }
    // Prevent loader from showing on admin users
    if (
      router.pathname === APP_PATHNAMES.admin &&
      (APP_SECTIONS_ROUTES.admin.some((path) => url.includes(path)) || url === '/')
    ) {
      return
    }
    // Prevent loader from showing on tenant finder
    if (
      router.pathname === APP_PATHNAMES.tenantFinder &&
      APP_SECTIONS_ROUTES.tenantFinder.some((path) => url.includes(path))
    ) {
      return
    }
    // Prevent loader from showing on upgrade plan
    if (router.pathname === APP_PATHNAMES.upgrade && APP_SECTIONS_ROUTES.upgrade.some((path) => url.includes(path))) {
      return
    }

    // Prevent loader from showing on owner reveal
    if (
      router.pathname === APP_PATHNAMES.ownerReveal &&
      APP_SECTIONS_ROUTES.ownerReveal.some((path) => url.includes(path))
    ) {
      return
    }
    setActive(true)
  }

  const handleRouteChangeComplete = () => {
    setActive(false)
  }

  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChangeStart)
    router.events.on('routeChangeComplete', handleRouteChangeComplete)
    router.events.on('routeChangeError', handleRouteChangeComplete)

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.events.off('routeChangeComplete', handleRouteChangeComplete)
      router.events.off('routeChangeError', handleRouteChangeComplete)
    }
  }, [])

  return <ContentLoader active={active} />
}
